import { useState, useEffect } from 'react';

const useGuestSession = (eventId) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSession = () => {
      try {
        const savedSession = localStorage.getItem('guestSession');
        
        if (!savedSession) {
          setSession(null);
          setLoading(false);
          return;
        }

        const parsedSession = JSON.parse(savedSession);
        
        // Verify session is for current event
        if (parsedSession.eventId !== eventId) {
          localStorage.removeItem('guestSession');
          setSession(null);
          setLoading(false);
          return;
        }

        // Check if session expired
        const expiresAt = new Date(parsedSession.expiresAt);
        if (expiresAt < new Date()) {
          localStorage.removeItem('guestSession');
          setSession(null);
          setLoading(false);
          return;
        }

        setSession(parsedSession);
        setLoading(false);
      } catch (error) {
        console.error('Error loading guest session:', error);
        localStorage.removeItem('guestSession');
        setSession(null);
        setLoading(false);
      }
    };

    loadSession();
  }, [eventId]);

  const clearSession = () => {
    localStorage.removeItem('guestSession');
    setSession(null);
  };

  return { session, loading, clearSession };
};

export default useGuestSession;
